import { Title, UnstyledButton, Image, Space, Center, Stack } from '@mantine/core';

import appleBadge from '@/assets/apple-badge.png';

export const Chat = () => {
  const handleClick = () => {
    window.open('https://apps.apple.com/app/ezocrm/id6661012995', '_blank');
  };

  return (
    <Center>
      <Stack align="center">
        <Title order={2}>Please download our app</Title>
        <Title fs="italic" order={6}>
          *Log in with manager's credentials to access messaging experience
        </Title>
        <Space h="lg" />
        <UnstyledButton onClick={handleClick}>
          <Image src={appleBadge} />
        </UnstyledButton>
      </Stack>
    </Center>
  );
};
